export default __webpack_public_path__ + "static/media/logo.c5e5c94e.png";